import script from "./SolutionView.vue?vue&type=script&lang=ts&setup=true"
export * from "./SolutionView.vue?vue&type=script&lang=ts&setup=true"

import "./SolutionView.vue?vue&type=style&index=0&id=ed5b2b7c&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed5b2b7c"]])

export default __exports__